import { initialThemeState } from "./../../reducers/themeReducer/themeReducer";

export const setThemeAction = (action = initialThemeState) => {
  if (action.skin) localStorage.setItem("skin", action.skin);

  return async (dispatch, getState) => {
    const payload = {
      ...getState().theme,
      ...action,
      isDarkMode: action.skin === "dark",
    };
    await dispatch({
      type: "SET_THEME",
      payload,
    });
  };
};

export const clearThemeAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_THEME" });
  };
};
